import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { AppState } from 'store/root-reducer';

import { CustomersBatchUploadsHistoryDataSource } from '../../datasources/customers-batch-uploads-history.data-source';

@Component({
  selector: 'artemis-customers-batch-upload-history',
  templateUrl: './customers-batch-upload-history.component.html',
  styleUrls: ['./customers-batch-upload-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomersBatchUploadHistoryComponent implements OnInit {

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  readonly displayedColumns: Array<string> = ['id', 'file', 'processed', 'created_at'];
  readonly pageSizeOptions: Array<number> = [10, 25, 50];

  customersBatchUploadsHistoryDataSource: CustomersBatchUploadsHistoryDataSource;

  constructor(private store: Store<AppState>,
              private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.setDataSource();
    this.customersBatchUploadsHistoryDataSource.loadData();
  }

  /**
   * Prepares data source
   * @method setDataSource
   */
  private setDataSource(): void  {
    this.customersBatchUploadsHistoryDataSource = new CustomersBatchUploadsHistoryDataSource(this.store);
    this.customersBatchUploadsHistoryDataSource
      .initDataSource({sort: this.sort, paginator: this.paginator, paginatorConfigs: {pageSizeOptions: this.pageSizeOptions}});
    this.cdRef.detectChanges();
  }
}
